import React, { useState, useRef, useEffect } from 'react';
import './Autocomplete.css';

function Autocomplete({ options, value, onChange, placeholder, displayKey, valueKey }) {
  const [searchTerm, setSearchTerm] = useState('');
  const [showDropdown, setShowDropdown] = useState(false);
  const [filteredOptions, setFilteredOptions] = useState([]);
  const wrapperRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (value && options.length > 0) {
      const selected = options.find(opt => opt[valueKey] === value);
      if (selected) {
        setSearchTerm(selected[displayKey]);
      }
    } else {
      setSearchTerm('');
    }
  }, [value, options, displayKey, valueKey]);

  const handleInputChange = (e) => {
    const term = e.target.value;
    setSearchTerm(term);
    setShowDropdown(true);

    if (term.trim() === '') {
      setFilteredOptions(options);
      onChange('');
    } else {
      const filtered = options.filter(option =>
        option[displayKey].toLowerCase().includes(term.toLowerCase())
      );
      setFilteredOptions(filtered);
    }
  };

  const handleSelectOption = (option) => {
    setSearchTerm(option[displayKey]);
    onChange(option[valueKey]);
    setShowDropdown(false);
  };

  const handleFocus = () => {
    setShowDropdown(true);
    setFilteredOptions(options);
  };

  return (
    <div className="autocomplete-wrapper" ref={wrapperRef}>
      <input
        type="text"
        value={searchTerm}
        onChange={handleInputChange}
        onFocus={handleFocus}
        placeholder={placeholder}
        className="autocomplete-input"
      />
      {showDropdown && filteredOptions.length > 0 && (
        <div className="autocomplete-dropdown">
          {filteredOptions.slice(0, 100).map((option) => (
            <div
              key={option[valueKey]}
              className="autocomplete-option"
              onClick={() => handleSelectOption(option)}
            >
              {option[displayKey]}
            </div>
          ))}
          {filteredOptions.length > 100 && (
            <div className="autocomplete-option disabled">
              ... and {filteredOptions.length - 100} more. Keep typing to filter.
            </div>
          )}
        </div>
      )}
      {showDropdown && searchTerm && filteredOptions.length === 0 && (
        <div className="autocomplete-dropdown">
          <div className="autocomplete-option disabled">No results found</div>
        </div>
      )}
    </div>
  );
}

export default Autocomplete;
